import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React, {ReactElement} from "react";
import {StyledListItem} from "@/shared/StyledComponents";
import {PAGE_FRAGMENT_WIDTH, PD_LG} from "@/shared/dimens";
import {Box, SvgIcon} from "@mui/material";
import {sleep} from "@/shared/sleep";
import {PracticeData} from "@/libwyze-shared/types";
import {CreatePracticeSiteFragment} from "./CreatePracticeSiteFragment";
import {BusinessOutlined} from "@mui/icons-material";
import {Site, Sites} from "../../vantage-shared/types";

export class SiteHelper {

  static createNew(): void {
    const id = BaseApp.CONTEXT.showCustomDialog("Create Site", <CreateSiteView
      onSiteActionClicked={(action: CreateSiteAction) => {
        BaseApp.CONTEXT.hideDialog(id);
        setTimeout(() => {
          switch (action.id) {
            case "practice": {
              const id = BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_DISABLE_BACKDROP_CLICK | DIALOG_FLAG_SHOW_CLOSE}, () =>
                <CreatePracticeSiteFragment finish={(site: Site) => {
                  BaseApp.CONTEXT.hideDialog(id);
                  setTimeout(() => {
                    BaseApp.CONTEXT.showProgressDialog("Please wait...", null, async function () {
                      await sleep(3000);
                      await new Sites(PracticeData.provider().practiceId).addListItem(site)
                    });
                  }, 100)
                }}/>);
              break;
            }
          }
        }, 100);
      }}
    />);
  }
}

type CreateSiteAction = {
  id: string,
  title: string,
  text: string,
  iconType: typeof SvgIcon,
}

const CREATE_SITE_ACTIONS: CreateSiteAction[] = [
  {
    id: "practice",
    title: "Create a Practice website",
    text: "Use our comprehensive site builder to create a website for your practice.",
    iconType: BusinessOutlined,
  },
];

function CreateSiteView({onSiteActionClicked}: {
  onSiteActionClicked: (action: CreateSiteAction) => void
}): ReactElement {
  return <Box
    style={{display: "flex", flexDirection: "column", padding: PD_LG, maxWidth: PAGE_FRAGMENT_WIDTH}}>
    {CREATE_SITE_ACTIONS.map(action => <StyledListItem
      onClick={() => onSiteActionClicked(action)}
      title={action.title}
      text={action.text}
      textWrap={true}
      icon={action.iconType}/>)}
  </Box>;
}
